var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('div',{staticClass:"h-screen"}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 left-0 h-screen w-full flex justify-center items-center"},[_c('LoaderSvg',{staticClass:"logo"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }